// Module
var code = `<div class="alert">
  <div>
    <strong>DISCLAIMER:</strong><br><br>
    This form can be used to update the GL balances for the chosen branch.<br>
    This operation resets all the GL balances for the chosen branch to 0.
    After doing this, it applies all values from the provided CSV file. The operation validates the format
    of the CSV and if anything is wrong, it returns an error.<br><br>
    The required format looks like this:<br><br>
    <strong>
      FULL/CODE/OF/ACCOUNT;123.34<br>
      FULL/CODE/OF/ANOTHER;665.99<br>
      FULL/CODE/WITH/NEGATIVE/VALUE;-999<br>
    </strong><br>
    The following restrictions to the CSV file apply:<br>
    * The CVS does not contain a header.<br>
    * It cannot contain parent nodes.
  </div>
</div>
<div class="alert alert--danger">
  All values for the given branch will be overwritten. This action cannot be reverted.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select required
                ng-model="\$ctrl.command.branchId"
                ng-options="entry.id as entry.name for entry in \$ctrl.branches">
        </select>

      </td>
    </tr>
    <tr>
      <td>CSV separator:</td>
      <td>
        <select required
                ng-model="\$ctrl.command.separator"
                ng-options="entry.value as entry.label for entry in \$ctrl.separators">
        </select>

      </td>
    </tr>
    <tr>
      <td>CSV:</td>
      <td>
        <textarea required
                 rows="20"
                 style="width: 100%"
                 ng-model="\$ctrl.command.csv">
        </textarea>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/reset-ledger-balance/reset-ledger-balance.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;